module.exports = __webpack_public_path__ + "static/media/support-mobile-bg.7a718933.jpg";